// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1qZ3h","header":"ReportDetails_header__1KsqR","title":"ReportDetails_title__SZh7H","left":"ReportDetails_left__2JygE"};